<template>
<div >
    <p class="title">招标文件</p>
    <div>
        <p>1、查看招标文件信息。</p>
        <img src="../assets/help/1.6.3-1.jpg" alt="">
        <p>2、点击“支付”，打开支付页面，完成支付技术服务费，以取得下载资格。</p>
        <img src="../assets/help/1.6.3-2.jpg" alt="">
        <p>3、点击“新增踏勘记录”，打开新增踏勘页面，新增踏勘记录。</p>
        <img src="../assets/help/1.6.3-3.jpg" alt="">
    </div>
</div>
</template>
<script>
export default {
    name:'center',
    data(){
        return{
            
        }

    }
}
</script>
<style>

</style>